export enum SnvrParts {
    TASKS = 'tasks',
    MANAGEMENT = 'management',
    SERVERS = 'servers',
    PREVIEW = 'preview',
    EVENTS = 'events',
    SEARCH_MAP = 'search_map',
    DOWNLOAD = 'download',
    CONTINUITY = 'continuity',
    VEHICLE_RECORDINGS = 'vehicle-recordings'
}

export function getAllSnvrParts(): string[] {
    return Object.values(SnvrParts);
}
